import { Modal } from 'antd'
import React, { FunctionComponent, useCallback, useState } from 'react'

import { MonitoringDedictviFetchResult } from '../../common/heritageMonitoringTypes'
import { Rizeni } from '../../common/proceedingTypes'
import { HeritageMonitoringFilter } from '../components/HeritageMonitoringFilter/HeritageMonitoringFilter'
import { HeritageMonitoringTable } from '../components/HeritageMonitoringTable/HeritageMonitoringTable'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { ProceedingDetailModalContent } from '../components/ProceedingDetailModalContent/ProceedingDetailModalContent'
import { PropertyMonitoringFetchError } from '../components/PropertyMonitoringFetchError/PropertyMonitoringFetchError'
import { PropertyMonitoringTablePagination } from '../components/PropertyMonitoringTablePagination/PropertyMonitoringTablePagination'
import { useFetchHeritageMonitoring } from '../utils/useFetchHeritageMonitoring'
import { useHeritageMonitoringFilter } from '../utils/useHeritageMonitoringFilter'
import { useFormattedProceeding } from '../utils/useProceedingString'

export const HeritageMonitoring: FunctionComponent = () => {
  const { filter, filterQuery, handleChange } = useHeritageMonitoringFilter()
  const [selectedProceeding, setSelectedProceeding] = useState<Rizeni | null>(
    null
  )

  const { proceedingTitle } = useFormattedProceeding(selectedProceeding)
  const dataSource = useFetchHeritageMonitoring(
    filterQuery
  ) as MonitoringDedictviFetchResult

  const handleModalClose = useCallback(() => {
    setSelectedProceeding(null)
  }, [])

  return (
    <>
      <PageLayout title="Monitoring dědictví - výpis řízení">
        <HeritageMonitoringFilter filter={filter} handleChange={handleChange} />

        {dataSource?.error ? (
          <PropertyMonitoringFetchError type="dědictví" />
        ) : (
          <HeritageMonitoringTable
            loading={!!dataSource?.fetching}
            data={dataSource?.data?.data}
            onProceedingClick={setSelectedProceeding}
          />
        )}

        <PropertyMonitoringTablePagination
          changePage={handleChange}
          currentPage={filter.stranka}
          hasNextPage={!!dataSource.data?.dalsiStranka}
        />
      </PageLayout>

      {selectedProceeding && (
        <Modal
          title={`Detail řízení ${proceedingTitle}`}
          width={1400}
          open={!!selectedProceeding}
          onCancel={handleModalClose}
          footer={null}
          destroyOnClose
        >
          <ProceedingDetailModalContent proceeding={selectedProceeding} />
        </Modal>
      )}
    </>
  )
}

export default HeritageMonitoring
